import Configuration from './Configuration'

const rootReducer = Configuration;
export default rootReducer;
